import { Modal, ModalCancelButton, ModalCloseButton, ModalConfirmButton, ModalWidth } from '@dreryk/react-components';

import { visitDetailsTranslationKeys } from '../../../../../../translations';

import { DiagnosisAdditionalInformationForm } from './DiagnosisAdditionalInformationForm';
import { VisitDiagnosisUpdateAdditionalInformationAction } from './DiagnosisAdditionalInformationModal.actions';
import { OnDiagnosisAdditionalInformationChanged } from './DiagnosisAdditionalInformationModal.types';

type DiagnosisAdditionalInformationModalProps = {
   readonly additionalInformation: string | null;
   readonly code: string;
   readonly name: string;
   readonly onClose: VoidFunction;
   readonly onSuccess: OnDiagnosisAdditionalInformationChanged;
   readonly visitId: number;
};

export const DiagnosisAdditionalInformationModal = (props: DiagnosisAdditionalInformationModalProps): JSX.Element => {
   return (
      <Modal
         testId={'diagnosisAdditionalInformationModal'}
         width={ModalWidth.NORMAL}
         title={visitDetailsTranslationKeys.diagnoses.diagnosisAdditionalInformation.modal.title}
      >
         <DiagnosisAdditionalInformationForm
            code={props.code}
            name={props.name}
            additionalInformation={props.additionalInformation}
         >
            {({ handleSubmit, formState }) => (
               <>
                  <VisitDiagnosisUpdateAdditionalInformationAction
                     code={props.code}
                     onSuccess={props.onSuccess}
                     visitId={props.visitId}
                  >
                     {({ updateAdditionalInformation }) => (
                        <ModalConfirmButton
                           label={
                              visitDetailsTranslationKeys.diagnoses.diagnosisAdditionalInformation.modal.actions.confirm
                                 .label
                           }
                           onClick={handleSubmit(updateAdditionalInformation)}
                        />
                     )}
                  </VisitDiagnosisUpdateAdditionalInformationAction>

                  <ModalCancelButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                  <ModalCloseButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
               </>
            )}
         </DiagnosisAdditionalInformationForm>
      </Modal>
   );
};
